import { IStoreState } from '../types';

export const getCurrentNetworkingLoungeUsers = (state: IStoreState) => state.networkingRoomLounge.loungePresentUser;
